
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/africa/purchase-pass",
      function () {
        return require("private-next-pages/africa/purchase-pass.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/africa/purchase-pass"])
      });
    }
  